import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DocketEntriesState = {
  createdDocketEntryId: null,
}

export const DocketEntriesActions = {
  fetchDocketEntries: async ({ commit, dispatch }, requestData) => {
    return axiosRequest.
      get(`/legal_cases/${requestData.legalCaseId}/docket_entries`, { params: requestData.params }).
      then(({ data }) => {
        commit('setDocketEntriesModel', data?.docket_entries, { root: true })
        dispatch(`${DOCKET_ENTRY_NAMESPACE}/totalDocketEntryIds`, data?.total_docket_entry_ids, { root: true })
        return {
          totalCount: data.total_count,
          totalCountForCase: data.total_entries_for_case,
          resultsThisPage: data.results_this_page,
          currentPage: data.current_page ? data.current_page : null,
        }
      }).catch(handleError)
  },

  setCreatedDocketEntryId: async ({ commit }, docketEntryId) => {
    commit('setCreatedDocketEntryId', docketEntryId)
  },
}

export const DocketEntriesMutations = {
  setCreatedDocketEntryId: (state, data) => { state.createdDocketEntryId = data },
}

export const DocketEntriesGetters = {
  createdDocketEntryId: state => state.createdDocketEntryId,
}
